import { useEffect, useState } from 'react';
import { api } from '../../utils/api';

/** The loan list is paginated; the badge counts every proposed loan, not one page. */
export function useSanctionQueueCount(enabled: boolean, refreshKey: string): number | null {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    setCount(null);
    if (!enabled) return;
    let alive = true;
    api
      .get('/loan-records/loans', { params: { status: 'SANCTION_PROPOSED', pageSize: 1 } })
      .then(({ data }) => {
        if (alive && Number.isSafeInteger(data.total) && data.total >= 0) setCount(data.total);
      })
      .catch(() => {
        if (alive) setCount(null);
      });
    return () => {
      alive = false;
    };
  }, [enabled, refreshKey]);
  return enabled ? count : null;
}
